import smartSolveApi from './instances/smartsolve';

const getUserData = async (type) => {
  try {
    const response = await smartSolveApi.post('/userdata', {
      action: 'get',
      type,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getUserData() failed: ${e}`);
  }
};

const addUserData = async (type, { virtualFilePath, entityType, entityKey, queryString }) => {
  try {
    const response = await smartSolveApi.post('/userdata', {
      action: 'add',
      type,
      virtualFilePath,
      entityType,
      entityKey,
      queryString,
    });

    return response.data;
  } catch (e) {
    throw new Error(`addUserData() failed: ${e}`);
  }
};

const removeUserData = async (type, { virtualFilePath, entityType, entityKey, queryString }) => {
  try {
    const response = await smartSolveApi.post('/userdata', {
      action: 'delete',
      type,
      virtualFilePath,
      entityType,
      entityKey,
      queryString,
    });

    return response.data;
  } catch (e) {
    throw new Error(`removeUserData() failed: ${e}`);
  }
};

// Recent Events
export const getRecentEvents = async () => getUserData('recentEvents');
export const addRecentEvent = async (params) => addUserData('recentEvents', params);

// Favorites
export const getFavorites = async () => getUserData('favorites');
export const addFavorite = async (params) => addUserData('favorites', params);
export const removeFavorite = async (params) => removeUserData('favorites', params);

export const getUserRolesAndRight = async () => {
  try {
    const response = await smartSolveApi.post('/userrolesandrights');
    return response.data;
  } catch (e) {
    throw new Error(`getUserRolesAndRight() failed: ${e}`);
  }
};

export const getUserHasManageRights = async (entityName) => {
  try {
    const response = await smartSolveApi.post('/hasmanagerights', { entityName });
    return response.data;
  } catch (e) {
    throw new Error(`getUserHasManageRights failed: ${e}`);
  }
};
